import { getSalesCampaignDetail } from '../../../api/salesCampaignApi'
import SalesCampaignDescriptions from '../../../components/sales-campaigns/sales-campaign-descriptions/sales-campaign-descriptions'
import translate from '../../../i18n'
import { ISalesCampaign } from '../share-type'
import styles from './sales-campaign.module.less'
import { Button, Space } from 'antd'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { compose } from 'redux'

const SalesCampaign = () => {
  const params = useParams()
  const [salesCampaignId] = useState<string | undefined>(params?.id)
  const [salesCampaign, setSalesCampaign] = useState<ISalesCampaign>()
  const navigate = useNavigate()

  useEffect(() => {
    if (salesCampaignId) {
      getSalesCampaignDetail(Number(salesCampaignId)).then(res => {
        setSalesCampaign(res)
      })
    }
  }, [salesCampaignId])

  const goBack = () => {
    navigate(-1)
  }

  return (
    <Space className={styles['sales-campaign-desc-wrapper']} orientation="vertical" size={16}>
      {salesCampaign && <SalesCampaignDescriptions salesCampaign={salesCampaign} />}
      <Button className={styles['button-group']} onClick={goBack}>
        {translate('goBack')}
      </Button>
    </Space>
  )
}

const mapStateToProps = () => ({})

const withConnect = connect(mapStateToProps)

export default compose(withConnect)(SalesCampaign)
